var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnansweredReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 41C30.6127 41 38 33.6127 38 24.5C38 15.3873 30.6127 8 21.5 8C12.3873 8 5 15.3873 5 24.5C5 27.8247 5.98331 30.9197 7.67497 33.5101L5.71004 39.0119C5.42625 39.8065 6.19351 40.5737 6.98812 40.29L12.4899 38.325C15.0803 40.0167 18.1753 41 21.5 41Z",
    fill: "#111B48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 38C34.6127 38 42 30.6127 42 21.5C42 12.3873 34.6127 5 25.5 5C16.3873 5 9 12.3873 9 21.5C9 24.8247 9.98331 27.9197 11.675 30.5101L9.71004 36.0119C9.42625 36.8065 10.1935 37.5737 10.9881 37.29L16.4899 35.325C19.0803 37.0167 22.1753 38 25.5 38Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.675 30.5101L12.1458 30.6782L12.2293 30.4445L12.0936 30.2367L11.675 30.5101ZM9.71004 36.0119L10.1809 36.18H10.1809L9.71004 36.0119ZM10.9881 37.29L10.82 36.8191H10.82L10.9881 37.29ZM16.4899 35.325L16.7633 34.9064L16.5555 34.7707L16.3218 34.8542L16.4899 35.325ZM41.5 21.5C41.5 30.3366 34.3366 37.5 25.5 37.5V38.5C34.8888 38.5 42.5 30.8888 42.5 21.5H41.5ZM25.5 5.5C34.3366 5.5 41.5 12.6634 41.5 21.5H42.5C42.5 12.1112 34.8888 4.5 25.5 4.5V5.5ZM9.5 21.5C9.5 12.6634 16.6634 5.5 25.5 5.5V4.5C16.1112 4.5 8.5 12.1112 8.5 21.5H9.5ZM12.0936 30.2367C10.4534 27.7251 9.5 24.7247 9.5 21.5H8.5C8.5 24.9247 9.5132 28.1143 11.2563 30.7835L12.0936 30.2367ZM10.1809 36.18L12.1458 30.6782L11.2041 30.3419L9.23917 35.8437L10.1809 36.18ZM10.82 36.8191C10.4226 36.961 10.039 36.5774 10.1809 36.18L9.23917 35.8437C8.81348 37.0356 9.96437 38.1865 11.1563 37.7608L10.82 36.8191ZM16.3218 34.8542L10.82 36.8191L11.1563 37.7608L16.6581 35.7959L16.3218 34.8542ZM25.5 37.5C22.2753 37.5 19.2749 36.5466 16.7633 34.9064L16.2165 35.7437C18.8857 37.4868 22.0753 38.5 25.5 38.5V37.5Z",
    fill: "#111B48"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 21.5,
    r: 1.5,
    fill: "#111B48"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 21.5,
    r: 1.5,
    fill: "#111B48"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 21.5,
    r: 1.5,
    fill: "#111B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnansweredReviews);
export default __webpack_public_path__ + "static/media/UnansweredReviews.b60852b6f1b75328d0f0b144a0fde53f.svg";
export { ForwardRef as ReactComponent };